/**
 * Class Carousel - creates a carosel when instantiated 
 * https://engineertodeveloper.com/create-a-carousel-with-vanilla-javascript/
 * @param {string} arg1 The ID of the html element that will contain the carousel.
 * @param {Array.<number>} arg2 an integer that represents the height in px of the carousel
 * @htmlFormat 
 *  <div id="sliderElem" class="slider">
        <div class="slider-item active">content</div>
        <div class="slider-item"> content </div>
        <div class="slider-item">content </div>

        <span class="slider-control-prev" role="button">
          <img aria-hidden="true" src="img/prev.svg" alt="Previous Slide Button">
        </span>
        <span class="slider-control-next" role="button">
          <img aria-hidden="true" src="img/next.svg" alt="Next Slide Button">
        </span>
    <div>  
 */

    //remove height parameter and have tailwind in template file do that. 
export class Carousel {
    constructor(sliderElem) {
        this.slider = document.getElementById(sliderElem);
        this.sliderItems = this.slider.querySelectorAll('.slider-item');
        this.nextBtn = this.slider.querySelector(".slider-control-next");
        this.prevBtn = this.slider.querySelector(".slider-control-prev");
        this.currentIndex = 0;
        this.prevItemIndex = this.sliderItems.length - 1;
        this.nextItemIndex = 1;
        this.isSliding = false;
        this.intervalID = null;
        this.setEventListeners();
    
        this.go();
    }
  
    setIndices(direction) { 
      let index;
      if (direction === "NEXT") {
          index = this.currentIndex === this.sliderItems.length - 1 ? 0 : this.currentIndex + 1;
      } 
      if (direction === "PREV") {
          index = this.currentIndex === 0 ? this.sliderItems.length - 1 : this.currentIndex - 1;
      }
      if (index === 0) {
          this.currentIndex = index;
          this.nextItemIndex = index + 1;
          this.prevItemIndex = this.sliderItems.length - 1;
      } else if (index === this.sliderItems.length - 1) {
          this.currentIndex = this.sliderItems.length - 1;
          this.nextItemIndex = 0;
          this.prevItemIndex = this.currentIndex - 1;
      } else {
          this.currentIndex = index;
          this.nextItemIndex = index + 1;
          this.prevItemIndex = index - 1;
      }
    }
  
    next() {
      if (this.isSliding) return;
      this.stop();
      this.isSliding = true;
      this.sliderItems[this.nextItemIndex].classList.add("next-item");

  
      setTimeout(() => {
        this.sliderItems[this.currentIndex].classList.add("slide-next");
        this.sliderItems[this.nextItemIndex].classList.add("slide-end");
        this.sliderItems[this.nextItemIndex].classList.add("active");
      }, 20);
  
      setTimeout(() => {
        this.sliderItems[this.nextItemIndex].classList.remove("next-item", "slide-end");
        this.sliderItems[this.currentIndex].classList.remove("slide-next", "active");
        this.isSliding = false;
        this.setIndices("NEXT");
      }, 400);


      this.go();
    }
  
    prev() {
      if (this.isSliding) return;
      this.stop();
      this.isSliding = true;
      this.sliderItems[this.prevItemIndex].classList.add("prev-item");


  
      setTimeout(() => {
        this.sliderItems[this.currentIndex].classList.add("slide-prev");
        this.sliderItems[this.prevItemIndex].classList.add("slide-end");
        this.sliderItems[this.prevItemIndex].classList.add("active");
      }, 20);
  
      setTimeout(() =>  {
        this.sliderItems[this.prevItemIndex].classList.remove("prev-item", "slide-end");
        this.sliderItems[this.currentIndex].classList.remove("slide-prev", "active");
        this.isSliding = false;
        this.setIndices("PREV");
      }, 400);

      this.go();
    }
  
    go() {
      this.intervalID = setInterval(() => {
        this.next();
      }, 3500);
    }

    stop() {
      clearInterval(this.intervalID);
      this.intervalID = null;
    }
  
    
    setEventListeners() {
      if (this.nextBtn && this.prevBtn){
        this.prevBtn.addEventListener("click", () => {
            this.prev();
        });
    
        this.nextBtn.addEventListener("click", () => {
            this.next();
        })
      }
    }
  }


  
